import React from 'react';

import type { GIFData } from './../../ricos-schema/next-schema';
import type { NodeViewRenderer, NodeViewRendererProps } from './../../ricos-types';

import { ViewerFigure } from '../../_shared/figure/viewer-figure';
import { Giphy } from './giphy';

const ViewerGiphy = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer,
}: NodeViewRendererProps) => {
  return (
    <ViewerFigure
      node={node}
      nodeIndex={nodeIndex}
      NodeViewContainer={NodeViewContainer}
      RicosNodesRenderer={RicosNodesRenderer}
    >
      <Giphy componentData={node.gifData as GIFData} nodeId={node.id} />
    </ViewerFigure>
  );
};

const GiphyRenderer: NodeViewRenderer = ({ node, ...props }) => {
  return <ViewerGiphy key={node.id} node={node} {...props} />;
};

export default GiphyRenderer;
